module.exports = {
      id: "wallet-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.09862bea.svg#wallet",
      toString: function () {
        return this.url;
      }
    }